
import { Component, Vue, Watch } from "vue-property-decorator";
import QuestionCard from "@/components/question/QuestionCard.vue"; //题卡
import CandidateListForm from "@/lib/form/candidate/CandidateListForm"; //候选人列表 查询参数
import ExamList from "@/lib/model/exam/exam"; //候选人列表 model
import { AI, Candidate, CvData, Dimension, PP } from "@/lib/model/exam/result"; //候选人信息 model
import MsgRequest from "@/lib/model/message/MsgRequest";
import {
  CandidateResult,
  Exam,
  R,
  ImgInfo,
  QuestionScore
} from "@/lib/model/exam/result"; //候选人试卷内容 model
import { Answer, FingerCheckResult, Param } from "@/lib/model/exam/result"; //候选人答案内容
import { Question } from "@/lib/model/question/question"; //题目model
import request from "@/lib/request/request";
import Auth from "@/lib/common/auth";
import Url from "@/lib/common/url";
import Cookie from "@/lib/common/cookie";
import Constraint from "@/lib/common/constraint";
import dayjs from "dayjs";
import { CompanyConfig } from "@/lib/common/acm";
import Loading from "../../components/loading.vue";
import vuexStore from "@/store/vuex-store";
import AddCandidateTags from "../paper/components/add-candidate-tags.vue";
import Candidater, { CandidateDeleteTags } from "@/lib/model/exam/candidate";
import { ExamInfo } from "@/lib/model/exam/candidate";
import { HR } from "@/lib/model/group/group";
import Pop from "@/views/ai-builder/components/blue-pop.vue";
import track from "@/lib/common/track";
// import toolkit from "@/util/toolkit"
import EchartsDisc from "@/views/paper/components/echarts-disc.vue";
import { Permission } from "@/lib/model/common";
import SingleDimensionMindRes from "@/components/single-dimension-mind-res.vue";
import { ZhuoMuNiao } from "@/views/news/resultInfo";
import { AllOptionText } from "@/lib/model/workerbuilder/exam-v3";
import { EnumTagColor, EnumTagMap, EnumTagType } from "@/lib/enum/tags";
import { getAssetsFile } from "@/lib/util/url";
import Decrypt from "@/lib/model/decryptParams/decryptParams";

interface Tags {
  tagType: number;
  tagName: string;
  enable: boolean;
  tagShort: string;
  tagColor?: string;
}

//评估结果
enum auditTextEnum {
  "待评估",
  "通过",
  "待定",
  "拒绝"
}
//形体检查
enum bodyStatus {
  "未按要求拍摄",
  "无纹身疤痕",
  "检测到疤痕",
  "检测到纹身",
  "检测到疤痕和纹身"
}
enum ydgdBodyStatus {
  "未按要求拍摄",
  "无残缺残疾",
  "不明显残疾",
  "明显残疾"
}
//面试（提交）状态
enum submitStatus {
  "未登记",
  "答题中",
  "待评估枚举",
  "已登记"
}
//异常项
enum errorEnum {
  "screenshot" = "多次截屏",
  "mobileJoinCount" = "多次切屏",
  "replacePerson" = "疑似换人",
  "readCheating" = "疑似念稿",
  "readingDetection" = "疑似念稿",
  "nameIdCheck" = "二要素核验未通过",
  "faceCheck" = "身份认证失败",
  "finger" = "手部检测未通过",
  "webJump" = "Web疑似切屏",
  "eyeColor" = "辨色检测未通过",
  "faceDetection" = "露脸检测未通过"
  // "bgCheck" = "背调不通过",
  // "bgCheckSocial" = "有社会安全风险",
  // "bgCheckFinancial" = "有金融风险",
  // "bgCheckIdentity" = "手机号实名异常"
}
enum enumFinger {
  "未按要求拍摄" = 0,
  "通过" = 1,
  "有异常" = 2,
  "考察项未配置" = 255
}

@Component({
  components: {
    QuestionCard,
    Loading,
    AddCandidateTags,
    Pop,
    EchartsDisc,
    SingleDimensionMindRes
  }
})
export default class PaperMark extends Vue {
  showMark = false; //展示评语
  searchName = "";
  searchType = "0"; //0未审核1通过2待定3拒绝
  peopleList: any[] = []; //左侧列表
  questionList: Question[] = []; //所有题目
  questionListDef: Question[] = []; //所有题目初始态
  dimensionReport: AI[] = []; // 按维度打分
  answerList: Answer[] = []; //候选人的回答
  infoList: any[] = []; //头部个人信息
  connectCode = 0; //当前connectCode
  candidateListForm = new CandidateListForm();
  resultStatus = 0; //最终评定
  resultText = "";
  exam = new Exam();
  unLogin = true; //匿名页面
  reviewer = ""; //阅卷人
  waitingQList: Answer[] = []; //待阅题目
  canChange = false; //修改结果
  scoreAll = 0; //试卷总分
  page = 1; //分页
  pageSize = 20;
  moreText = "加载更多...";
  all = new CandidateResult();
  paperInfo = new Candidate();
  command = "";
  canWait = false;
  paperDataReady = false;
  submitting = false;
  marked = true;
  showWarning = false;
  timeTag = 0; //时间标记 用于销毁asr轮询
  scoreHrTotal: any = ""; //招行Hr 印象分
  sourceInfoMap: any = {}; // 原始评价相关信息

  // 打开页面时间
  startTime: any;
  // 上次回到页面时间
  lastActiveTime: any;
  // 页面活跃时长
  activeDuration = 0;
  // 播放了哪些题目的视频列表
  playedIdList: any | null;

  isBlur = false;

  // 提交评估时间
  endTime: any;
  cvData: CvData = new CvData(); //工单数据
  isWorker = false; // 是否普工版
  FSKInfoList: any = []; //富士康 个人基本信息
  markeTime = "";
  down = false; //收起
  fskBodyInfo = new Answer(); //形体检查
  ydgdBodyInfo = new Answer(); //手臂检查
  // ydgdBodyInfoShow = false; //手臂检查 有数据

  gwList: any = []; //岗位适应
  bgList: any[] = []; //背调信息
  pcList: any[] = []; //身份核验信息
  mindScore: any = {};
  mindQuestion: any = []; //心理题
  mLimit = 3; //展示数量限制
  mindQuestionLeft: any = [];
  mindQuestionRight: any = [];
  mindQuestion1: any = []; //ydgd 心理题用 三个维度
  mindQuestion2: any = [];
  mindQuestion3: any = [];
  fk = false;
  cvDataOver = true; //是否完成填写
  superMark = false; //是否数据标注模式 此模式需登录、
  spmkNoLogin = false; //标注模式 未登录
  spmkNoCompany = false; //标注模式 公司id不正确
  spmkNoOther = false;
  realHeadPhotoUrl = "";
  isNotYours = false; //标注模式 url公司id 与 当前cookie不符
  checkList = false; //是否重新加载以修正左侧list
  listReady = false;
  hideAiScore = false; //隐藏ai打分
  mindData = new Answer();
  connectCompanyId = 0; //根据链接码获取的companyId
  showIDPhoto = false;
  V = vuexStore;
  candidateParams: any = false; //候选人列表页带过来的条件
  errorInfoList: any = []; //异常检测 截屏
  // gameQiFSK: any = {};
  showMIndQuestion = false;
  showBigImg = false;
  bigImgUrl = "";
  isYD = false;
  mindQAList: PP[] = []; //普工心理题
  newPsy: any = ""; // 新版普工心理测评20231109

  selectIndex = -1;

  // 候选人标签相关
  showAddTag = false;
  deleteTagsForm = new CandidateDeleteTags();
  isManyHr = false;
  otherHrDialog = false;
  otherHrTag = false;
  privacy =
    "以上资料保证完整、真实并愿意接受集团背景。本人承诺：如有不实或隐瞒（含学历、经历、集团工作亲属信息、既往病史及目前健康状况等），本人愿接受公司解除劳动合同处理。";
  hasChange = false;
  scoreVersion = 0; // 打分规则版本 -> 左侧公司的打分规则版本，需要登陆
  rightScoreVersion = 0; // 右侧候选人的打分规则版本
  tags: Tags[] = [];

  //总得分
  get totalScore() {
    let t = 0;
    this.answerList.forEach((d: any) => {
      t += Number(d?.scoreHr) || 0;
    });
    return t < 0 ? 0 : t;
  }
  //总题目数量
  get allQuestionNum() {
    return this.questionList.filter((d: any) => {
      return !d?.isTestResultQuestion;
    }).length;
  }
  //待评分题目
  get waitingScored() {
    this.waitingQList = this.answerList.filter((d: Answer, i: number) => {
      return !this.questionList[i]?.isTestResultQuestion && d.isScored === 0;
    });
    return this.waitingQList.length;
  }

  get getMindQuestionLeft() {
    return JSON.parse(JSON.stringify(this.mindQuestionLeft)).splice(
      0,
      this.mLimit
    );
  }
  get getMindQuestionRight() {
    return JSON.parse(JSON.stringify(this.mindQuestionRight)).splice(
      0,
      this.mLimit
    );
  }
  get getColorQuestion() {
    return this?.all?.questionAnswerMap?.[102]?.[0];
  }
  //AI评估中
  get isAIing() {
    return this.paperInfo.aiProcessStatus !== 3;
  }

  //是否隐藏手机号
  get isHidePhone() {
    return CompanyConfig.getInstance(this.connectCompanyId).isHidePhone === 1;
  }
  //是否展示简历链接
  get isShowAttachment() {
    return CompanyConfig.getInstance().isShowAttachment === 1;
  }
  //评语是否必填
  get isMustText() {
    return (
      CompanyConfig.getInstance(this.connectCompanyId).isMustResultText === 1
    );
  }
  //评语最低字数
  get resultMinNumber() {
    return CompanyConfig.getInstance(this.connectCompanyId).resultTextMinNumber;
  }
  //小维度打分（需ACM与该场面试配置同时打开）
  get isMarkDimensionScore() {
    return (
      CompanyConfig.getInstance(this.connectCompanyId).isMarkDimensionScore ===
        1 && this.all.exam.isMarkDimensionScoreExam === 1
    );
  }
  get fskQuestionList() {
    return this.questionList.filter(q => {
      return ![6, 999, 104, 105, 102].includes(q.type);
    });
  }
  get fskAnswerList() {
    return this.answerList.filter(q => {
      return ![6, 999, 104, 105, 102].includes(q.type);
    });
  }
  //打气球游戏数据
  get gameQi() {
    const t = this.all?.questionAnswerMap?.[107].find((d: any) => {
      return d?.answer?.gameTestAnswerResult?.gameTestType === 1;
    });
    return (
      t?.answer?.gameTestAnswerResult ?? new Answer()?.gameTestAnswerResult
    );
  }
  //西蒙斯游戏数据
  get gameXi() {
    const t = this.all?.questionAnswerMap?.[107].find((d: any) => {
      return d?.answer?.gameTestAnswerResult?.gameTestType === 2;
    });
    return (
      t?.answer?.gameTestAnswerResult ?? new Answer()?.gameTestAnswerResult
    );
  }
  //手指检测109
  get finger() {
    return (
      this.all?.questionAnswerMap?.[109]?.[0]?.answer?.fingerCheckResult ||
      new FingerCheckResult()
    );
  }
  get fingerAnswer() {
    return this.all?.questionAnswerMap?.[109]?.[0]?.answer || new Answer();
  }
  //是否展示工单
  get showGD() {
    return this.paperInfo.needCv === 1;
  }
  limit100(v: any) {
    if (!v) return;
    return;
  }

  get AIScoreAll() {
    if (this.dimensionReport && this.dimensionReport.length) {
      return this.dimensionReport?.reduce(
        (pre, cur) =>
          ({ scoreAi: this.numAdd(pre.scoreAi, cur.scoreAi) } as any)
      ).scoreAi;
    } else {
      return 0;
    }
  }

  get handScoreAll() {
    if (this.dimensionReport && this.dimensionReport.length) {
      return this.dimensionReport?.reduce(
        (pre, cur) =>
          ({ score: this.numAdd(Number(pre.score), Number(cur.score)) } as any)
      ).score;
    } else {
      return 0;
    }
  }
  get scoreAiByDimAdd(): number {
    return Math.round(
      this.dimensionReport.reduce((pre, cur) => {
        return pre + cur.scoreAi;
      }, 0)
    );
  }

  fixZero(i: number) {
    const str = i.toString();
    console.log(str.indexOf("."));
    return str.indexOf(".") === -1
      ? str + ".00"
      : str.split(".")[1].length === 1
      ? str + "0"
      : str;
  }

  getJudge(i: number) {
    return this.all?.judgeResult?.questionScoreList?.[i] || new QuestionScore();
  }

  numAdd(num1: number, num2: number) {
    let baseNum = 10;
    let baseNum1, baseNum2;
    try {
      baseNum1 = num1.toString().split(".")[1].length;
    } catch (e) {
      baseNum1 = 0;
    }
    try {
      baseNum2 = num2.toString().split(".")[1].length;
    } catch (e) {
      baseNum2 = 0;
    }
    baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
    // let precision = baseNum1 >= baseNum2 ? baseNum1 : baseNum2 //精度
    return (num1 * baseNum + num2 * baseNum) / baseNum;
  }

  examList: any[] = [];
  searchInputValue = ""; //搜索面试名称
  //面试下拉搜索匹配
  get getOptions() {
    if (this.searchInputValue) {
      const t =
        this.examList?.filter((d: any) =>
          d.examName.includes(this.searchInputValue)
        ) || [];
      return [...t];
    } else {
      return this.examList || [];
    }
  }

  //筛选条件展示  无则不展示
  get showCandidateParams() {
    let text = ``;
    const t = this?.candidateParams;
    if (!t) return "";
    text +=
      t?.searchUserIdList?.length > 0
        ? `<span class="shuu">只看自己负责的候选人</span>`
        : ``;
    text +=
      t?.submitStatusList?.length > 0
        ? `<span class="shuu">面试状态：${
            t?.submitStatusList[0] !== 2
              ? submitStatus[t?.submitStatusList[0]]
              : t?.auditStatusList?.[0] === 0
              ? `待评估`
              : `已评估`
          }</span>`
        : ``;
    text +=
      t?.auditStatusList?.length === 1 && t?.auditStatusList?.[0] !== 0
        ? `<span class="shuu">评估结果：${
            auditTextEnum[t?.auditStatusList[0]]
          }</span>`
        : ``;
    text +=
      t?.showNameOrPhone?.length > 0
        ? `<span class="shuu">搜索候选人：${t?.showNameOrPhone}</span>`
        : ``;
    //时间文案处理
    // 做个判断，如果createdTime为空，则不展示
    if (t?.createdTime && t?.createdTime?.length > 0) {
      t.createdTime[0] =
        t?.createdTime?.[0] === "1970-01-01 00:00:00"
          ? "截至"
          : t?.createdTime?.[0] + " ~ ";
      t.createdTime[1] =
        t?.createdTime?.[1] === "2999-01-01 00:00:00"
          ? "至今"
          : t?.createdTime?.[1];
      t.createdTime =
        t.createdTime?.[0] === "截至" && t.createdTime?.[1] === "至今"
          ? []
          : t.createdTime;
      text +=
        t?.createdTime?.length > 0
          ? `<span class="shuu">创建时间：${t?.createdTime?.join("")}</span>`
          : ``;
    }
    text +=
      t?.tagNameList?.length > 0
        ? `<span  class="shuu" title=${t?.tagNameList.join(
            "，"
          )}>候选人标签：${t?.tagNameList.join("，")}</span>`
        : ``;
    return text ? `<span class="Ttitle">筛选条件</span>` + text : ``;
  }
  //是否AIbuilder公司阅卷 -展示维度和评分规则
  get isNewAi() {
    console.log(this.scoreVersion);
    return (
      ([
        80976,
        82070,
        80978,
        559,
        80933,
        80934,
        80935,
        81022,
        81023,
        81025,
        81027,
        81041,
        81044,
        81043,
        81042,
        81040,
        81039,
        89792,
        81177,
        81175,
        81191,
        81190,
        81189,
        81188,
        3
      ].includes(Number(Auth.companyId)) ||
        this.connectCompanyId >= 91353) &&
      ![91415, 194].includes(Number(Auth.companyId)) &&
      (Number(Auth.companyId) !== this.connectCompanyId
        ? this.scoreVersion === 1
        : true) // 当前登录的公司与链接吗公司不同时，使用scoreVersion
    );
  }
  //其他权限  list以外的都算
  otherPowerList = [
    "姓名",
    "姓名/手机",
    "手机",
    "邮箱",
    "身份证号",
    "新建时间",
    "面试状态",
    "通知状态",
    "提交时间",
    "交卷方式",
    "负责人",
    "身份证号",
    "身份证",
    "身份证号后6位",
    "AI打分",
    "AI推荐",
    "评估结果",
    "得分",
    "面试官评分",
    "AI评估说明",
    "面试官结果"
  ];
  // // 啄木鸟字段特殊处理
  // zmnData(zmn:any){
  // 	const value = zmn.value;
  // 	try {
  // 		//
  // 	} catch (error) {
  // 		//
  // 	}
  // }
  get paramListFilterByPower() {
    const res = this.infoList.filter(d => {
      return !(
        !this.$P.candidateInfo.other && !this.otherPowerList.includes(d.name)
      );
    });
    return res;
  }
  //是否可修改结果
  setCanChange() {
    this.canChange = !(
      //公司配置不可修改 且 已阅过卷
      (
        this.exam.companySpecialConfig.auditRepeat === 2 &&
        this.resultStatus !== 0
      )
    );
  }

  async created() {
    this.isNotYours =
      Cookie.get(Constraint.companyIdKey) !== this.$route.query.companyId;
    document.title = document.location.origin.includes("mianshi.nrpla")
      ? "牛人星球"
      : "海纳AI面试";
    await Permission.getPerm(); //拉下用户权限（非需登录页面，没有头所以独立拉一下）
    if (Auth.token) {
      // 登陆状态，公司的scoreVersion判断左侧的候选人列表样式
      MsgRequest.getCompanyInfo(parseInt(Auth.companyId)).then((res: any) => {
        this.scoreVersion = res.data.companySpecialConfig.scoreVersion;
      });
    }
  }
  async mounted() {
    //鉴权
    if (this.$route.query.tid) {
      this.tid = String(this.$route.query.tid);
    }
    // 记录阅卷时长
    this.initialTrack();
    const params = this.$route.query;
    //是否走多人评估流程
    if (params.judgeOutId && params.passwd) {
      this.isManyHr = true;
      this.candidateListForm.judgeOutId = String(params.judgeOutId);
      this.candidateListForm.passwd = String(params.passwd);
      //分配给此人的所有面试
      const hrInfo = await (HR.login({
        judgeOutId: params.judgeOutId,
        passwd: params.passwd
      }) as any);
      this.examList = hrInfo?.examList;
      // if (!params.connectCode) {
      //   params.connectCode = await this.getManyHrFirstCode(); //模拟带链接码进入
      // }
      this.scoreVersion = Number(params.scoreVersion);
    }
    this.reviewer = (params.user as string) || "";
    this.connectCode = Number(params?.connectCode);
    this.superMark = params?.isHrMark === "1";

    //判考试类型
    if (params?.connectCode) {
      //带链接码
      // 不需登陆，候选人下的评分规则配置，右侧优先用候选人的评分规则，控制右侧打分的新旧版，（切换候选人影响到左侧一会新版一会旧版看着很乱，所以左侧始终用公司下的新旧版配置）
      await CandidateResult.getCid(Number(params?.connectCode), this.tid).then(
        res => {
          this.isWorker = ["test", "aiworker"].includes(res.examType);
          this.isYD = [91415, 194].includes(Number(res.companyId));
          this.rightScoreVersion = res.scoreVersion;
        }
      );
    } else {
      //不带链接码
      this.isWorker = localStorage.getItem("isWorker") === "true";
      this.isYD = [91415, 194].includes(Number(params?.companyId));
      if (Auth.token) {
        if (localStorage.getItem("isWorker") === "true") {
          this.scoreVersion = 0;
        } else {
          await MsgRequest.getCompanyInfo(parseInt(Auth.companyId)).then(
            (res: any) => {
              this.scoreVersion = res.data.companySpecialConfig.scoreVersion;
            }
          );
        }
      }
    }
    if (!this.isYD && !this.isManyHr) {
      //候选人列表页跳转过来-带参
      this.candidateParams = JSON.parse(
        sessionStorage.getItem("candidateParams") || "false"
      );
      //左侧候选人列表查询参数  初始置为候选人页带入的查询参数
      this.candidateListForm =
        JSON.parse(JSON.stringify(this.candidateParams)) ||
        new CandidateListForm();
    }
    this.candidateListForm.pageSize = this.pageSize;
    this.candidateListForm.page = this.page;
    this.candidateListForm.examId = Number(params.examId) || 0;
    this.candidateListForm.companyId = Number(params.companyId);
    this.searchType = (params.auditStatus as string) || "0";
    this.candidateListForm.sortKey = "submit_time";
    this.candidateListForm.sortDict = "desc"; //降序
    this.candidateListForm.submitStatusList = [2]; //已交卷
    this.candidateListForm.afterBuy = 1; //已购买查看
    this.candidateListForm.examType = this.isYD
      ? ""
      : this.isWorker
      ? "aiworker"
      : "aibuilder";
    //查全公司
    this.candidateListForm.asCompany =
      this.candidateListForm.examId === 0 ? 1 : 0;

    this.setHeightCss(); //页面高度

    //是否 标注模式
    if (this.superMark) {
      this.checkSuperMark();
      return;
    }

    //是否 匿名处理（隐藏左侧列表）：
    // step1：入参包含examId companyId  且  step2: 调用list接口不报错; 或多人评估模式    除此之外 其余情况全部做匿名处理。
    //******step1******
    if ((Auth.token && params.examId && params.companyId) || this.isManyHr) {
      this.getList(params.connectCode ? false : true);
    } else {
      //匿名处理
      this.unLogin = true;
      this.selectCandidate({ connectCode: params.connectCode });
    }
  }

  // 左侧候选人分页
  handleSizeChange(pageSize: number) {
    this.candidateListForm.pageSize = pageSize;
    this.getList();
  }
  handleCurrentChange(pageNumber: number) {
    if (
      pageNumber === 0 ||
      pageNumber - 1 >=
        Math.ceil(
          this.candidateListForm.total / this.candidateListForm.pageSize
        )
    )
      return;
    this.candidateListForm.page = pageNumber;
    this.getList();
  }
  //多人评估 获取第一个候选人链接码
  async getManyHrFirstCode() {
    return "51100121850";
    // return await ExamList.getManyHrCandidateList(this.candidateListForm).then(
    //   (res) => {
    //     if (res?.data?.list.length) {
    //       return res.data.list[0].connectCode;
    //     }
    //   }
    // );
  }
  getIdName(id: number) {
    const t = this.getOptions.find(d => {
      return d.examId === id;
    });
    return t?.examName || "全部面试";
  }

  initialTrack() {
    this.startTime = new Date(); // 开始时间
    this.lastActiveTime = this.startTime;
    this.activeDuration = 0;
    this.isBlur = false;
    this.playedIdList = {};
    window.onfocus = () => {
      if (this.isBlur) {
        this.isBlur = false;
        this.lastActiveTime = new Date();
        // console.log("focus:" + this.lastActiveTime)
      }
    };
    window.onblur = () => {
      if (!this.isBlur) {
        this.isBlur = true;
        this.endTime = new Date();
        this.activeDuration += this.endTime - this.lastActiveTime;
        // console.log("blur:" + this.endTime)
        // console.log("initialTrack:" + this.activeDuration)
      }
    };
  }

  //数据标注模式 权限确认
  checkSuperMark() {
    // 此模式必须是 1.登录状态   且   2.公司id 考试id 链接码 参数匹配无误。    1 2 有误则走对应引导流程
    if (!Auth.token) {
      // 去登陆
      this.spmkNoLogin = true;
      this.getCandidatePaper(true);
      return;
    }
    if (this.isNotYours) {
      this.spmkNoCompany = true;
      this.getCandidatePaper(true);
      return;
    }

    this.candidateListForm.isHrMark = 1;
    this.getList(this.connectCode ? false : true);
  }
  //获取左侧候选人list 同时也是 校验页面入参
  async getList(showFirst = true, onlyGetList = false) {
    //******step2******
    this.candidateListForm.auditStatusList = [Number(this.searchType)]; //评估类型
    this.candidateListForm.ignore406 = true; //此页面忽略406报错
    this.listReady = false;
    ExamList[
      this.isManyHr
        ? "getManyHrCandidateList"
        : this.isYD
        ? "getFskCandidateList"
        : "getCandidateList"
    ](this.candidateListForm)
      .then(
        (res: any) => {
          try {
            //标注模式
            if (this.superMark) {
              if (res.code === 406) {
                //公司不匹配 旧版
                // this.spmkNoCompany = true;
                // this.getCandidatePaper(true);
                return;
              }
            }

            //已登陆 且 页面入参无误
            this.unLogin = false;
            this.peopleList = res.data.list; //peopleList不做类型判断 如果从后台获取到了非数组类型的数据 则视为参数校验未通过 走未登录的逻辑
            this.candidateListForm.total = res.data.count;
            if (this.peopleList.length === 0 && showFirst) {
              //无试卷时
              this.infoList = [];
              this.questionList = [];
              this.paperDataReady = true;
              return;
            }
            this.peopleList.forEach((d: any) => {
              d.submitTime = d.submitTime.substring(5, 10).split("-");
            });
            if (onlyGetList) return;
            //展示: 默认第一张试卷 或 指定候选人
            if (showFirst) {
              this.selectCandidate(res.data.list[0]); //默认加载第一张卷子
            } else {
              this.checkList = true;
              const candidateId = this.peopleList.find(
                el => String(el.connectCode) == String(this.connectCode)
              )?.candidateId;
              this.selectCandidate({
                connectCode: this.connectCode,
                candidateId
              }); //展示指定候选人
            }
          } catch (e) {
            if (this.superMark) return;
            //页面入参有误   做匿名处理
            console.log("有error则走匿名规则：" + e);
            this.unLogin = true;
            const candidateId = this.peopleList.find(
              el => String(el.connectCode) == String(this.connectCode)
            )?.candidateId;
            this.selectCandidate({
              connectCode: this.connectCode,
              candidateId
            });
          }
        },
        (res: any) => {
          if (this.superMark && res.data.code === -1) {
            //考试id 等 不匹配
            this.spmkNoOther = true;
            this.getCandidatePaper(true);
            return;
          }
        }
      )
      .finally(() => {
        setTimeout(() => {
          this.listReady = true;
        }, 200);
      });
  }
  candidateId = 0;
  //加载试卷
  async selectCandidate(d: any) {
    if (!d.connectCode) {
      console.log("无链接码！");
      return; //链接码必须
    }
    //点击左侧列表时，更新鉴权tid
    if (!this.unLogin && d.candidateId) {
      await Decrypt.get({
        candidateId: String(d.candidateId)
      }).then(res => {
        this.tid = res.tid;
      });
    }

    this.connectCode = Number(d.connectCode);
    this.selectIndex = this.peopleList.findIndex(
      el => el.connectCode == this.connectCode
    );
    this.getConnectCompanyId();

    Url.setQueryOnly("connectCode", String(this.connectCode)); //用户刷新保持当前卷子
    Url.setQueryOnly("auditStatus", String(this.searchType));

    this.paperDataReady = false; //先隐藏打分器

    this.getCandidateInfo();
    this.fk = false;
    this.listReady = false;

    this.initialTrack();
  }
  //获取顶部个人信息
  async getCandidateInfo() {
    Candidate.get({
      connectCode: this.connectCode,
      reviewer: this.reviewer,
      isHrMark: this.superMark ? 1 : 0,
      judgeOutId: this.candidateListForm.judgeOutId,
      passwd: this.candidateListForm.passwd,
      tid: this.tid
    }).then((res: Candidate) => {
      res.paramList = res.paramList.filter(d => {
        return d.isShow === 1;
      });
      //***数据按照从短到长 处理排序***
      const arrL: any[] = []; //长选项
      const arrS: any[] = []; //短选项
      const w =
        document.getElementsByClassName("countRightWidth")?.[0]?.clientWidth ||
        1200;
      const limit = (w - 64) / 3 - 10;
      res?.paramList.forEach((d: Param, i: number) => {
        if (
          d?.name.length * 14 +
            (d.inputType === "file" ? 4 : d?.cascadeValue.length) * 16 >
          limit
        ) {
          this.$set(res.paramList[i], "long", true);
          arrL.push(d);
        } else {
          this.$set(res.paramList[i], "long", false);
          arrS.push(d);
        }
      }); //信息超长 最后单独一行    3月5号 改成不排序了
      // this.infoList = [...arrS, ...arrL];
      this.infoList = res?.paramList;
      if (this.isHidePhone) {
        //隐藏手机号
        this.infoList = this.infoList.filter(d => {
          return d.name !== "手机";
        });
      }
      //***END***/

      this.resultStatus = res.auditStatus; //评定结果
      //******非自动加载第一张试卷时： 根据链接码反的参数  修正左侧list入参  重新载入list*****
      if (this.checkList) {
        this.searchType = String(res.auditStatus);
        // this.candidateListForm.examId = Number(res.examId);
        this.getList(false, true);
        this.checkList = false;
      }
      this.marked = res.auditStatus !== 0; //已阅过卷
      this.resultText = res.auditDesc;
      this.sourceInfoMap.resultText = this.resultText;
      this.paperInfo = res; //主表信息
      this.tags = [];
      this.tags.push(
        ...res.tags.map(item => ({
          tagType: EnumTagType.EnumTagTypeDefault,
          tagName: item,
          enable: false,
          tagShort: getAssetsFile("exam/tags.png"),
          textColor: "#805A30",
          tagColor: EnumTagColor[EnumTagMap[EnumTagType.EnumTagTypeDefault]]
        })),
        ...res.tagsInvite.map(item => ({
          tagType: EnumTagType.EnumTagTypeInvite,
          tagName: item,
          enable: false,
          tagShort: getAssetsFile("exam/tagsInvite.png"),
          textColor: "#4A5A30",
          tagColor: EnumTagColor[EnumTagMap[EnumTagType.EnumTagTypeInvite]]
        })),
        ...res.tagsAudit.map(item => ({
          tagType: EnumTagType.EnumTagTypeAudit,
          tagName: item,
          enable: true,
          textColor: "#804A4A",
          tagShort: getAssetsFile("exam/tagsAudit.png"),
          tagColor: EnumTagColor[EnumTagMap[EnumTagType.EnumTagTypeAudit]]
        })),
        ...res.tagsRule.map(item => ({
          tagType: EnumTagType.EnumTagTypeRule,
          tagName: item,
          enable: false,
          textColor: "#355670",
          tagShort: getAssetsFile("exam/tagsRule.png"),
          tagColor: EnumTagColor[EnumTagMap[EnumTagType.EnumTagTypeRule]]
        }))
      );
      console.log(this.tags);
      this.realHeadPhotoUrl = res?.photoUrl || ""; //证件照照片

      this.$nextTick(() => {
        if (this.$refs.showHeight) {
          (this.$refs.showHeight as HTMLElement).scrollTop = 0;
        }

        //截屏等 异常检测
        this.errorInfoList = [];
        // console.log("this.paperInfo.errorInfoList:", this.paperInfo);
        if (this.paperInfo.errorInfoList.length) {
          this.paperInfo.errorInfoList.forEach((d: any) => {
            if (!errorEnum[d.task]) return;
            if (d.result === 1) {
              this.errorInfoList.push({
                name: errorEnum[d.task],
                result: d.result
              });
            }
          });
        }
        //下一步加载试卷
        this.getCandidatePaper();
      });
    });
  }
  //截屏等 异常检测
  get errorInfoListAll() {
    const errorInfoList: any[] = [];
    if (this.all.errorInfoList.length) {
      this.all.errorInfoList.forEach((d: any) => {
        if (!errorEnum[d.task]) return;
        if (d.result === 1) {
          errorInfoList.push({
            name: errorEnum[d.task],
            result: d.result
          });
        }
      });
    }
    return errorInfoList;
  }
  //获取试卷内容
  getCandidatePaper(onlyGetCompanyInfo = false) {
    CandidateResult.get({
      connectCode: this.connectCode,
      reviewer: this.reviewer,
      isHrMark: this.superMark ? 1 : 0,
      judgeOutId: this.candidateListForm.judgeOutId,
      passwd: this.candidateListForm.passwd,
      tid: this.tid
    })
      .then((res: CandidateResult) => {
        if (onlyGetCompanyInfo) {
          this.exam = res.exam;
          return;
        }
        this.scoreAll = res.scoreAll;
        this.questionListDef = res.questionList;
        this.questionList = res.questionList;
        this.dimensionReport = res.dimensionReport;
        this.sourceInfoMap.resultStatus = this.resultStatus;
        this.dimensionReport.forEach(el => {
          const questionList: number[] = [];
          this.questionList.forEach((item, index: number) => {
            if (item.aiDimensionList.includes(el.dimension)) {
              questionList.push(index + 1);
            }
          });
          el.questionList = questionList;
        });
        this.sourceInfoMap.dimensionReport = JSON.parse(
          JSON.stringify(this.dimensionReport)
        );
        res.answerList.forEach((d: Answer) => {
          //未阅卷 且 Ai打分未出结果  则打分分值置空 (补充： 如果视频题未配置AI 也置空打分器)
          const AIingFlag =
            this.paperInfo.auditStatus === 0 &&
            d.type === 6 &&
            d.aiProcessStatus !== 3; //1未开始 2执行中 3已完成 255不需要
          //处理 标准题目
          d.scoreHr = AIingFlag ? undefined : d.scoreHr;
          //处理 ai小维度
          d.dimensionAnswerList.forEach((m: Dimension) => {
            m.scoreHr = (AIingFlag ? undefined : m.scoreHr) as any;
            m.scoreDefault = (AIingFlag ? undefined : m.scoreDefault) as any;
          });
        });
        //未阅卷 且 配置了隐藏AI打分 ->
        this.hideAiScore =
          this.paperInfo.auditStatus === 0 && res.exam.hideAiScore;
        //则 已作答的视频题 -> 处理成hr未打分状态
        res.answerList.forEach(d => {
          const flag = this.hideAiScore && d.type === 6 && d.isAnswered === 1;
          d.scoreHr = flag ? undefined : d.scoreHr;
          d.isScored = flag ? 0 : d.isScored;
          //小维度
          d.dimensionAnswerList.forEach((m: Dimension) => {
            (m.scoreHr as any) = flag ? undefined : m.scoreHr;
          });
        });
        this.answerList = res.answerList;
        this.exam = res.exam;
        this.all = res;
        this.timeTag = new Date().getTime();
        this.checkAiAsrStatus(res.answerList);
        this.setCanChange(); //是否可修改结果
        this.canWait =
          this.exam.companySpecialConfig.auditUndetermined === 1 ? true : false; //是否有待定
        // this.showMark = false;//刷新后收起
        if (this.isWorker) {
          this.setFSKAll(); //fsk相关
        }
        // this.isWorker = [90528, 91359, 91237, 91415, 1010, 173, 194].includes(
        //   res.companyId
        // );
        if (this.isWorker) {
          //富士康工单
          if (this.paperInfo.needCv === 1) {
            this.setFSKWorkInfo();
          }
          //心理测评结果：若 ai打分中且hr未阅卷 ；则 hr值置为0
          const showIng = this.isAIing && this.resultStatus === 0;
          this.paperInfo.testExamResultData.depressiveTestResultHr = showIng
            ? 0
            : this.paperInfo.testExamResultData.depressiveTestResultHr;
          this.paperInfo.testExamResultData.violentTestResultHr = showIng
            ? 0
            : this.paperInfo.testExamResultData.violentTestResultHr;
          //视频ai结果
          this.paperInfo.testExamResultData.violentTestResultAdmin = this
            .isAIing
            ? 0
            : this.paperInfo.testExamResultData.violentTestResultAdmin;
          this.paperInfo.testExamResultData.depressiveTestResultAdmin = this
            .isAIing
            ? 0
            : this.paperInfo.testExamResultData.depressiveTestResultAdmin;
        }
        this.setMindData(); //标准心理测试结果
        this.getBG(); //背调
        this.getPC(); //身份
        //隐藏重复身份证
        if (this.all.livenessRecognitionResult.isAssigned) {
          this.infoList = this.infoList.filter(d => {
            return d.inputType !== "idcard";
          });
        }
        //手部检测
        if (this.finger._isAssignedFlag) {
          //resultFlexible
          this.infoList.push({
            name: "手指灵活度",
            cascadeValue:
              this.fingerAnswer.isAnswered !== 1
                ? "未完成提交"
                : this.finger.resultFlexible === 1
                ? "通过"
                : "未通过"
          });
          this.infoList.push({
            name: "手指完整度",
            cascadeValue:
              this.fingerAnswer.isAnswered !== 1
                ? "未完成提交"
                : this.finger.resultComplete === 1
                ? "通过"
                : "未通过"
          });
          this.infoList.push({
            name: "手部疤痕纹身",
            cascadeValue:
              this.fingerAnswer.isAnswered !== 1
                ? "未完成提交"
                : this.finger.resultScar === 1
                ? "通过"
                : "未通过"
          });
          if (this.finger.resultArmComplete !== 255) {
            this.infoList.push({
              name: "完整展示",
              cascadeValue:
                this.fingerAnswer.isAnswered !== 1
                  ? "未完成提交"
                  : this.finger.resultArmComplete === 1
                  ? "通过"
                  : "未通过"
            });
          }
          if (this.finger.resultArmHide !== 255) {
            this.infoList.push({
              name: "撸袖子",
              cascadeValue:
                this.fingerAnswer.isAnswered !== 1
                  ? "未完成提交"
                  : this.finger.resultArmHide === 1
                  ? "通过"
                  : "未通过"
            });
          }
        }
        //色盲检测
        if (
          this.getColorQuestion &&
          this.getColorQuestion._isAssignedFlag &&
          this.isNewAi &&
          !this.isWorker
        ) {
          this.infoList.push({
            name: "辨色检测",
            cascadeValue:
              this.getColorQuestion.answer.testResult === 1 ? "通过" : "未通过"
          });
        }

        //hr手打总分开启 （招行）
        if (this.exam.isHrScore === 1) {
          this.scoreHrTotal =
            this.paperInfo.submitStatus === 2 &&
            this.paperInfo.auditStatus !== 0
              ? this.paperInfo.scoreHrTotal
              : undefined;
        }
        //hr手打总分 新版
        if (this.rightScoreVersion) {
          if (
            this.paperInfo.auditStatus !== 0 &&
            this.paperInfo.auditMember !== "AI"
          ) {
            //hr手打过分
            this.scoreHrNew = this.paperInfo.score;
            this.sourceInfoMap.scoreHrNew = this.scoreHrNew;
          } else {
            //hr未打过分 给个默认值
            this.scoreHrNew = this.scoreAiByDimAdd;
            this.sourceInfoMap.scoreHrNew = this.scoreHrNew;
          }
        }
        this.paperDataReady = true;
        this.listReady = true; //防止点太快
        if (this.otherHrDialog) {
          //弹窗复位一下
          this.otherHrDialog = false;
          this.$nextTick(() => {
            this.otherHrDialog = true;
          });
        }
      })
      .finally(() => {
        this.setCompanyLink();
        setTimeout(() => {
          this.paperDataReady = true;
          this.listReady = true;
        }, 10000);
      });
  }
  //加载更多候选人
  getMorePeople() {
    if (this.moreText === "已全部加载") return;
    this.candidateListForm.page = ++this.page;
    ExamList[
      this.isManyHr
        ? "getManyHrCandidateList"
        : this.isYD
        ? "getFskCandidateList"
        : "getCandidateList"
    ](this.candidateListForm).then(res => {
      if (res.data.list.length > 0) {
        res.data.list.forEach((d: any) => {
          d.name = d?.paramList?.[0]?.value || "";
          d.submitTime = d.submitTime.substring(5, 10).split("-");
        });
        this.peopleList = this.peopleList.concat(res.data.list);
        this.$forceUpdate();
      }
      if (res.data.list.length < this.pageSize) {
        this.moreText = "已全部加载";
      }
    });
  }
  optionAll: any = {}; //全量配置
  //富士康工单
  setFSKWorkInfo() {
    // //基础信息 固定
    // this.infoList = this.infoList.filter((a: any) => {
    //   return a.name === "姓名" || a.name === "手机";
    // });
    //工单
    CandidateResult.getFSK({ connectCode: this.connectCode }).then(
      (res: any) => {
        if (res?.data?.code === 0) {
          this.cvDataOver = res?.data?.data?.cvDataAfterSubmit ?? true; //是否完成工单填写
          this.cvData = res?.data?.data?.cvData ?? new CvData(); //工单
          // this.realHeadPhotoUrl = res?.data?.data?.passportPhotoUrl ?? ""; //证件照照片
          this.optionAll = res?.data?.data; //全量配置

          //空字段转 -
          for (const key in this.cvData) {
            if (this.cvData[key].constructor === Array) {
              this.cvData[key].forEach((row: any) => {
                for (const k in row) {
                  row[k] = row[k] === "" ? "-" : row[k];
                }
              });
            }
          }

          this.markeTime = res?.data?.data?.cvDataTime; //签字时间
        }
      }
    );
  }

  //富士康相关项
  setFSKAll() {
    //肢体
    this.getFSKBody();
    //岗位 todo 未阅卷时候样式
    // this.gwList = [
    //   {
    //     content: "夜班",
    //     type: this?.all?.headerDataList?.[1]?.[4]?.values?.[0]?.type,
    //   },
    //   {
    //     content: "无尘服",
    //     type: this?.all?.headerDataList?.[1]?.[3]?.values?.[0]?.type,
    //   },
    //   // ...this?.all?.headerDataList?.[2]?.[3]?.values,
    // ];
    // if (this?.all?.headerDataList?.[0]?.[3]?.values?.[0]?.type === 2) {
    //   this.gwList = [{ content: "未完成提交", type: 2 }];
    // }

    this.getMind(); //心理检测
    this.setBodyVideo(); //身体视频
  }
  scoreHrNew = 0;
  //使用新版阅卷
  get useNewMarkType(): boolean {
    return Boolean(
      this.scoreVersion && (this.unLogin || this.peopleList.length !== 0)
    );
  }
  tid = "";
  //交卷
  async submit() {
    try {
      this.endTime = new Date(); // 开始时间
      const usedTime = (this.endTime - this.startTime) / 1000;
      this.activeDuration += this.endTime - this.lastActiveTime;
      this.lastActiveTime = new Date();
      // console.log(`活动时长：${this.activeDuration/1000}`);
      // console.log(`总时长：${usedTime}`);

      const playedIdList = Object.keys(this.playedIdList);
      const logParams = {
        connectCode: this.connectCode,
        action: "audit_track",
        extraData: {
          candidate_id: this.paperInfo.candidateId,
          duration: usedTime,
          active_duration: this.activeDuration / 1000,
          startTime: dayjs(this.startTime).format("YYYY-MM-DD HH:mm:ss"),
          endTime: dayjs(this.endTime).format("YYYY-MM-DD HH:mm:ss"),
          audit_result: this.getAuditTextEnum(this.resultStatus),
          score_all: this.totalScore,
          platform: "web",
          played_id_list: playedIdList
        }
      };
      request.post("/aiExam/candidatePublic/log", logParams);
    } catch (e) {
      console.log(e);
    }

    if (!this.rightScoreVersion) {
      const notMarkItemList = this.answerList.filter(d => {
        return d.isScored === 0;
      });
      let needToMarkList: Answer[] = [];
      if (notMarkItemList.length) {
        needToMarkList = notMarkItemList.filter(d => {
          return d.isAnswered === 1;
        });
      }
      //AI未完成打分时  且 hr未打分  (非fsk)
      if (!this.isWorker && needToMarkList.length) {
        const notMarkIndex = this.answerList.findIndex(d => {
          return d.questionId === needToMarkList[0].questionId;
        });
        (this.$refs["qCard" + notMarkIndex]?.[0] as HTMLElement).scrollIntoView(
          {
            behavior: "smooth",
            block: "start"
          }
        );
        this.warn("请给此题打分");
        this.answerList.forEach(d => {
          d.showMarkTip = d.isScored === 0 ? true : false;
        });
        return;
      }
    }
    //必填校验
    if (
      this.exam.companySpecialConfig.auditDescMust === 1 &&
      this.resultText.length < 1
    ) {
      this.warn("请输入总体评价");
      return;
    }
    //新 公司acm配置 必填校验
    if (this.isMustText && this.resultText.length < 1) {
      this.warn("请输入总体评价");
      return;
    }
    // 评价最少字数
    if (
      this.resultMinNumber !== 0 &&
      this.resultText.length < this.resultMinNumber
    ) {
      this.warn("总体评价至少需" + this.resultMinNumber + "个字");
      return;
    }
    if (this.resultStatus === 0) {
      this.warn("请选择评估结果");
      return;
    }
    //招行 hr手打总分
    // if (
    //   this.exam.isHrScore === 1 &&
    //   [undefined, ""].includes(this.scoreHrTotal)
    // ) {
    //   this.warn("请输入HR评分");
    //   return;
    // }
    // if (
    //   this.isWorker &&
    //   (this.paperInfo.testExamResultData.depressiveTestResultHr === 0 ||
    //     this.paperInfo.testExamResultData.violentTestResultHr === 0)
    // ) {
    //   this.warn("请对候选人进行心理测评评估");
    //   return;
    // }
    // if (this.isWorker && this.fskBodyInfo.testResult === 0) {
    //   this.warn("请对候选人进行形体检查评估");
    //   return;
    // }

    this.submitting = true;

    let allLastScore = 0;
    //只传修改过的分数  -> 现在改成所有模式 视频题和音频题 全量传 其余都不传
    const list: any[] = [];
    // console.log(this.answerList)
    this.answerList.forEach((d: Answer) => {
      //开启小维度打分时 传分：
      if (this.isMarkDimensionScore) {
        if ([6, 8].includes(d.type) && d.dimensionAnswerList.length > 0) {
          // let t = 0;
          // d.dimensionAnswerList.forEach((m: Dimension) => {
          //   t += m.scoreHr !== m.scoreDefault ? 1 : 0; //如果有维度被修改了
          // });
          // if (t || this.superMark) {
          // d.dimensionAnswerList.forEach(dimension => {
          //   this.dimensionReport.forEach(AI => {
          //     if (dimension.dimensionName === AI.dimension) {
          //       dimension.scoreHr = AI.score;
          //     }
          //   });
          // });
          list.push({
            questionId: d.questionId,
            dimensionAnswerList: d.dimensionAnswerList
          });
        }
        // }
      } else {
        //常规传分
        // if (this.superMark ? true : d.score !== d.scoreHr) {//改动过的分数  标注模式则全传
        if ([6, 8].includes(d.type)) {
          list.push({ questionId: d.questionId, score: d.scoreHr });
        }
      }
      allLastScore += Number(d.scoreHr);
    });
    //HR 打tag
    const tagList: any[] = [];
    this.all.answerList.forEach((d: Answer) => {
      if (d.questionTagList.length) {
        tagList.push({
          questionId: d.questionId,
          questionTagList: d.questionTagList
        });
      }
    });

    const params: any = {
      connectCode: this.connectCode,
      auditStatus: this.resultStatus,
      auditDesc: this.resultText,
      tid: this.tid,
      tagList
    };
    if (this.scoreVersion === 1) {
      // 新版
      params.dimensionScoreList = this.dimensionReport.map(el => ({
        dimensionName: el.dimension,
        score: el.score
      }));
    } else {
      params.scoreList = list;
    }
    params.score = allLastScore;
    params.connectCode = this.connectCode;
    params.reviewer = this.reviewer;
    //hr手打总分（招行）
    if (this.exam.isHrScore === 1) {
      params.scoreHrTotal = this.scoreHrTotal;
    }
    //hr手打总分（最新版使用） 评估页右侧用候选人的版本
    if (this.rightScoreVersion) {
      params.scoreHr = this.scoreHrNew;
    }
    //富士康
    if (this.isWorker) {
      // params.depressiveTestResultHr = this.paperInfo.testExamResultData.depressiveTestResultHr; //抑郁
      // params.violentTestResultHr = this.paperInfo.testExamResultData.violentTestResultHr; //暴力
      // params.scoreList.push({
      //   questionId: this.fskBodyInfo.questionId,
      //   testResult: this.fskBodyInfo.testResult
      // }); //形体
    }
    //标注提交
    if (this.superMark) {
      params.isHrMark = 1;
    }
    //多人面试官
    if (this.isManyHr) {
      params.judgeOutId = this.candidateListForm.judgeOutId;
      params.passwd = this.candidateListForm.passwd;
    }

    request
      .post("aiExam/auditPublic/submit", params)
      .then(async (resp: { data: any }) => {
        if (resp.data.code === 0) {
          if (Auth.token && !this.unLogin) {
            //登录且正确展示左侧list时
            this.getList();
          }
          this.showMark = false;
          this.$message.success("提交成功！");
          this.marked = true; //防止匿名时重复原卷
          this.setCanChange();
        } else {
          //
        }
      })
      .finally(() => {
        this.submitting = false;
      });
  }
  //富士康 形体数据
  getFSKBody() {
    const t = this.questionList.findIndex(d => {
      return d.type === 104;
    });
    this.fskBodyInfo = this.answerList[t] ?? new Answer();
    //手臂检查 友达光电
    const t2 = this.all.questionList.findIndex(d => {
      return d.type === 108;
    });
    this.ydgdBodyInfo = this.all.answerList[t2] ?? new Answer();
    // if (t2 !== -1) {
    //   this.ydgdBodyInfoShow = true;
    // } else {
    //   this.ydgdBodyInfoShow = false;
    // }
  }
  //背调结果
  getBG() {
    enum errorLevel {
      "原数据",
      "存在低风险",
      "存在中风险",
      "存在高风险",
      "存在异常风险"
    }
    const socialStatus = new AllOptionText().socialStatus;
    const b = this.paperInfo.bgCheckResult;
    const {
      financialRiskErrorLevel,
      financialRiskStatus,
      socialInfoErrorLevel,
      socialInfoStatus
    } = this.paperInfo.bgCheckResult;
    this.bgList = [];
    if (![0, 255].includes(b.identityInfoStatus)) {
      this.bgList.push({
        title: "手机号实名认证",
        text: b.identityInfoStatus === 2 ? "通过" : "未通过",
        status: socialStatus[b.identityInfoStatus].status
      });
    }
    if (![0, 255].includes(b.socialInfoStatus)) {
      this.bgList.push({
        title: "社会安全风险",
        text:
          socialInfoErrorLevel &&
          socialInfoErrorLevel > 0 &&
          socialInfoStatus === 3
            ? errorLevel[socialInfoErrorLevel]
            : b.socialInfoStatus === 2
            ? "通过"
            : socialStatus[b.socialInfoStatus].text,
        status: socialStatus[b.socialInfoStatus].status
      });
    }
    if (![0, 255].includes(b.financialRiskStatus)) {
      this.bgList.push({
        title: "金融风险",
        text:
          financialRiskErrorLevel &&
          financialRiskErrorLevel > 0 &&
          financialRiskStatus === 3
            ? errorLevel[financialRiskErrorLevel]
            : b.financialRiskStatus === 2
            ? "通过"
            : socialStatus[b.financialRiskStatus].text,
        status: socialStatus[b.financialRiskStatus].status
      });
    }
  }
  //身份核验相关
  getPC() {
    this.pcList = [];
    const a = this.all?.livenessRecognitionResult;
    if (a._isAssignedFlag) {
      this.pcList.push({
        title: "身份认证",
        text: !a.isTested ? "未完成提交" : a.isPass === 1 ? "通过" : "未通过",
        type: a.isPass === 1 ? 2 : 1
      });
    }
    const b = this.paperInfo?.replaceCheckResult;
    if (b._isAssignedFlag) {
      this.pcList.push({
        title: "换人检测",
        text:
          b.result === 0 ? "未完成提交" : b.result === 2 ? "通过" : "未通过",
        type: b.result === 2 ? 2 : 1
      });
    }
    const c = this.paperInfo.bgCheckResult.identityInfoStatus;
    if (![0, 255].includes(c)) {
      this.pcList.push({
        title: "手机号实名认证",
        text: c === 102 ? "未授权" : c === 2 ? "通过" : "未通过",
        type: c
      });
    }
  }

  getHrSc(i: number) {
    return auditTextEnum[this.all.judgeResult.auditStatusList[i]];
  }

  downMind() {
    this.mLimit = this.mLimit === 3 ? 8 : 3;
    if (this.mLimit === 3) {
      (this.$refs.anchorCP as HTMLElement).scrollIntoView({
        behavior: "auto",
        block: "start"
      });
    }
  }
  getMind() {
    this.mindQuestion = [];
    this.newPsy = "";
    this.mindQAList = [];
    let aData: any = {};
    let newPsy: any = ""; // 普工更新成最新的心理测评，旧面试不变，新创建的变
    this.all.answerList.forEach((d: any) => {
      if (d.type === 105) {
        aData = d;
      }
      if (d.type === 106) {
        // 普工最新心理测评
        newPsy = d;
      }
    });
    if (!aData?.psychologicalQuestionAnswerResult && !newPsy) return;
    if (this.isYD) {
      //友达光电版
      aData?.psychologicalQuestionAnswerResult?.psychologicalAnswerList.forEach(
        (d: any) => {
          this.mindQuestion.push({
            desc: d.questionDesc,
            level: d.level,
            answer: d.answerDesc || "未作答"
          });
        }
      );
      // this.mindScore = aData?.psychologicalQuestionAnswerResult || new R(); //心理题 得分
      // this.mindQuestionLeft = [...this.mindQuestion].slice(0, 16); //作答展示
      // this.mindQuestionRight = [...this.mindQuestion].slice(16);
      this.mindQuestion1 = [...this.mindQuestion].slice(0, 10); //ydgd 心理题 10道 * 3个维度
      this.mindQuestion2 = [...this.mindQuestion].slice(10, 20);
      this.mindQuestion3 = [...this.mindQuestion].slice(20, 30);
    } else {
      // 2023.11.9最新心理测评
      if (newPsy) {
        this.newPsy = newPsy;
        this.mindQAList = [];
        return;
      } else {
        this.newPsy = "";
      }
      //普工心理题 类型list 最新
      this.mindQAList =
        aData?.psychologicalQuestionAnswerResult?.psycDimensionList;
    }
  }

  setBodyVideo() {
    const v: any = this.$refs.BodyVideo;
    if (!v) return;
    v.addEventListener("play", () => {
      this.pauseOther(123, "形体检查");
    });
  }
  //链接码对应公司ID
  getConnectCompanyId() {
    CandidateResult.getCid(Number(this.connectCode), this.tid).then(
      (res: any) => {
        this.connectCompanyId = res.companyId;
        this.rightScoreVersion = res.scoreVersion;
      }
    );
  }
  //评语插入文本
  resultAddText(d: string) {
    //已有则不加
    if (this.resultText.indexOf(d) !== -1) return;
    //是否隔断前一句
    const t = this.resultText.slice(this.resultText.length - 1);
    console.log(t);
    d = [
      ",",
      ".",
      ";",
      "，",
      "。",
      "、",
      "；",
      "：",
      ":",
      "?",
      "？",
      "!",
      "！",
      "~",
      ""
    ].includes(t)
      ? d
      : "；" + d;
    this.resultText += d + "；";
    this.$message.success("已将此考察点加入总体评价");
  }

  //防重复提示
  warn(t: string) {
    if (!this.showWarning) {
      this.$message.warning(t);
      this.showWarning = true;
      setTimeout(() => {
        this.showWarning = false;
      }, 3000);
    }
  }

  //头像缺失
  defImg(event: any) {
    const img = event.srcElement;
    img.src = require("../../assets/head-logo-long.png");
    img.onerror = null; //防止闪图
  }
  //状态名称
  getAuditTextEnum(i: number) {
    return auditTextEnum[i];
  }
  //选中结果
  setRes(i?: number) {
    if (!this.canChange) return; //不可修改
    if (!i) {
      //点击修改 置为未阅卷状态
      this.marked = false;
      // this.resultStatus = 0;
      this.showMark = true;
      return;
    }
    this.showMark = true;
    this.resultStatus = i;
    this.setDefText(i);
  }
  //自动填充默认评语
  setDefText(i: number) {
    if (this.resultStatus !== this.sourceInfoMap.resultStatus) {
      this.hasChange = true;
    }
    if (!this.isWorker) return;
    this.resultText =
      i === 1
        ? "HR评估通过"
        : i === 2
        ? "候选人有重点关注项未通过，请注意"
        : "HR评估拒绝";
  }

  //排序
  sort(d: any) {
    track("audit_page_interact", {
      exam_id: this.candidateListForm ? this.candidateListForm.examId : 0,
      exam_name: this.exam.name,
      exam_remark: this.exam.remark,
      candidate_id: this.paperInfo.candidateId,
      operation_type: "排序",
      operation_name: d
    });
    this.candidateListForm.sortKey = d;
    this.command = d;
    this.getList();
  }
  //搜索
  search() {
    track("audit_page_interact", {
      exam_id: this.candidateListForm ? this.candidateListForm.examId : 0,
      exam_name: this.exam.name,
      exam_remark: this.exam.remark,
      candidate_id: this.paperInfo.candidateId,
      operation_type: "搜索",
      operation_name: this.searchName
    });
    this.candidateListForm.page = 1;
    this.candidateListForm.showNameLike = this.searchName;
    this.getList();
  }
  //切换tab
  clickTab(a: any) {
    this.searchType = a.name; //类型
    this.page = 1;
    this.candidateListForm.page = this.page;
    this.moreText = "加载更多...";
    this.getList();
  }
  //检查所有AI打分题目的 转文本状态 asr
  checkAiAsrStatus(paperData: any) {
    //无需转换（255）  已完成（3） 则展示，转换中（2）则上定时
    const waitingAsrList: any[] = [];
    paperData.forEach((d: Answer, i: number) => {
      if (d.asrStatus === 2) {
        waitingAsrList.push({ questionId: d.questionId, index: i });
      }
    });
    this.querryAsrResult(waitingAsrList);
  }

  //asr结果轮询
  querryAsrResult(waitingAsrList: any[]) {
    waitingAsrList.forEach(d => {
      this.querryRequest(d.questionId, d.index, this.timeTag);
    });
  }

  //定时查询
  querryRequest(id: string, index: number, now: number) {
    request
      .post("aiExam/auditPublic/asrFinish", {
        connectCode: this.connectCode,
        questionId: id
      })
      .then(res => {
        if (res.data.code === 0) {
          if (res.data.data.asrFinish === true) {
            // 已完成 更新数据
            this.$set(
              this.answerList,
              index,
              new Answer().assign(res.data.data.answer)
            );
          } else {
            //未完成 继续查询
            if (this.timeTag === now) {
              setTimeout(() => {
                this.querryRequest(id, index, now);
              }, 10000);
            }
          }
        }
      });
  }
  //收起
  downM() {
    this.down = !this.down;
    if (!this.down) {
      (this.$refs.anchorGD as HTMLElement).scrollIntoView({
        behavior: "auto",
        block: "start"
      });
    }
  }
  //跳登录
  toLogin() {
    window.open("/");
  }
  toReload() {
    // window.reload("");
    location.replace("");
  }
  //根据头部高度 控制页面整体高度滚动
  setHeightCss() {
    (this.$refs["flex-box"] as any)?.style?.setProperty(
      "--height",
      this?.showCandidateParams ? "38px" : "0px"
    );
  }
  armImgUrl(i: number) {
    return this?.ydgdBodyInfo?.bodyCheckAnswer?.imgList?.[i]?.imgUrl;
  }
  //打开简历
  showAttachment(url?: string) {
    const h = window.outerHeight;
    const w = Math.max((window.innerWidth - 840) / 2, 540);
    const left =
      (window.screenX || window.screenLeft || 0) + window.innerWidth - w;
    window.open(
      url || this.paperInfo.attachmentUrl,
      "_blank",
      `height=${h}, width=${w}, top=0, left=${left}, toolbar=no, menubar=no, scrollbars=no,location=no, resizable=yes, directories=yes, status=no`
    );
  }
  //默认隐藏第二三题
  fku(toAnchor = true) {
    this.fk = !this.fk;
    if (!this?.questionList?.[1]?.type) return;
    if (this.fk) {
      this.questionList[1].type = 999;
      this.questionList[2].type = 999;
      if (toAnchor) {
        this.tt();
      }
    } else {
      this.questionList[1].type = 6;
      this.questionList[2].type = 6;
    }
  }
  tt() {
    (this.$refs.anchorYC as HTMLElement).scrollIntoView({
      behavior: "auto",
      block: "start"
    });
  }
  //标准心理结果
  setMindData() {
    this.mindData =
      this.all?.questionAnswerMap?.[106]?.[0]?.answer ?? new Answer();
  }
  //形体结果
  bodyEnum(d = new ImgInfo()) {
    let t = bodyStatus[d?.result];
    //人脸为1
    if (d?.imgUrl === "1") {
      t = d?.result === 1 ? "通过" : "未通过";
    }
    t = this.isAIing ? "AI评估中" : t;
    // const c = [0, 1].includes(d?.result) ? "#8590A6FF" : "#FF5055FF";
    let color =
      d?.result === 0 ? "#8590A6FF" : d?.result === 1 ? "#27ba9c" : "#e64340ff";
    color = this.isAIing ? "#8590A6FF" : color;
    return `<span style="color:${color};margin-left:12px;font-weight: 600;">${t}</span>`;
  }
  //手臂结果
  ydgdBodyEnum(i: number) {
    const d1 = this.ydgdBodyInfo.bodyCheckAnswer?.imgList?.[i]?.result;
    const d2 = this.ydgdBodyInfo.bodyCheckAnswer?.imgList?.[i + 1]?.result;
    if (d1 === undefined || d2 === undefined) return;
    //取最坏的结果
    let result = Math.max(d1, d2);
    //有一个未拍摄则算未拍摄（0）
    result = [d1, d2].includes(0) ? 0 : result;
    let t = ydgdBodyStatus[result];
    t = this.isAIing ? "AI评估中" : t;
    const color =
      result === 0 ? "#8590A6FF" : result === 1 ? "#27ba9c" : "#e64340ff";
    return `<span style="color:${color};margin-left:12px;font-weight: 600;">${t}</span>`;
  }

  fingerResText(i: number) {
    return enumFinger[i];
  }
  //自动暂停其他视频
  pauseOther(qIndex: number, questionId: string) {
    if (!this.playedIdList) this.playedIdList = {};
    this.playedIdList[questionId] = true;
    console.log(this.playedIdList);
    const list = this.$refs.QC as HTMLElement[];
    list.forEach((d: any) => {
      d.pauseMe(qIndex);
    });
  }

  addTag(tags = []) {
    this.showAddTag = false;
    this.paperInfo.tags = tags;
    this.getCandidateInfo();
  }
  delTag(it: Tags) {
    this.deleteTagsForm.connectCode = this.connectCode;
    this.deleteTagsForm.companyId = this.candidateListForm.companyId;
    this.deleteTagsForm.tags = [it.tagName];
    this.deleteTagsForm.judgeOutId = this.candidateListForm.judgeOutId;
    this.deleteTagsForm.passwd = this.candidateListForm.passwd;
    this.deleteTagsForm.tagType = it.tagType;

    Candidater.candidateDeleteTagsHr(this.deleteTagsForm).then(res => {
      if (res.code === 0) {
        this.paperInfo.tags = res.data.tags;
        this.$message.success("删除标签成功");
        this.getCandidateInfo();
      }
    });
  }
  //查看大图
  openImg(url?: string) {
    this.bigImgUrl = url || "";
    this.showBigImg = true;
  }
  get AVG() {
    let all = 0;
    this.all.answerList.forEach((d, i, arr) => {
      if ([6, 8].includes(d.type)) {
        all +=
          Number(this.all?.judgeResult?.questionScoreList?.[i]?.score?.avg) ||
          0;
      } else {
        all += Number(d?.scoreHr) || 0;
      }
    });
    return all;
  }
  get AVG2() {
    let all = 0;
    this.all.answerList.forEach((d, i, arr) => {
      if ([6, 8].includes(d.type)) {
        all +=
          Number(this.all?.judgeResult?.questionScoreList?.[i]?.score?.avg2) ||
          0;
      } else {
        all += Number(d?.scoreHr) || 0;
      }
    });
    return all;
  }
  //使用平均分
  useAvg(flag: number) {
    if (flag === 1) {
      //用平均分
      this.all.answerList.forEach((d, i, arr) => {
        if ([6, 8].includes(d.type)) {
          arr[i].scoreHr =
            this.all.judgeResult.questionScoreList[i].score.avg || 0;
        }
      });

      this.all.answerList.forEach((d, i, arr) => {
        if ([6, 8].includes(d.type)) {
          d.dimensionAnswerList.forEach((m, n, arrs) => {
            arrs[n].scoreHr = Number(
              this.all.judgeResult.questionScoreList[i].dimensionAnswerList[n]
                .scoreHr.avg || 0
            );
          });
        }
      });
    } else {
      //用去极值平均分
      this.all.answerList.forEach((d, i, arr) => {
        if ([6, 8].includes(d.type)) {
          arr[i].scoreHr =
            this.all.judgeResult.questionScoreList[i].score.avg2 || 0;
        }
      });

      this.all.answerList.forEach((d, i, arr) => {
        if ([6, 8].includes(d.type)) {
          d.dimensionAnswerList.forEach((m, n, arrs) => {
            arrs[n].scoreHr = Number(
              this.all.judgeResult.questionScoreList[i].dimensionAnswerList[n]
                .scoreHr.avg2 || 0
            );
          });
        }
      });
    }
    this.$message.success("分数应用成功");
  }
  setCompanyLink() {
    const company = this.exam.company;
    if (company.shortname) {
      document.title = company.shortname.substring(0, 6);
    }
    if (company.companyIcon) {
      let link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
      if (!link) {
        link = document.createElement("link") as HTMLLinkElement;
      }
      if (link) {
        link.rel = "icon";
        link.href = company.companyIcon;
        document.head.appendChild(link);
      }
    }
  }
  // 打分输入框分数限制
  scoreInput(item: AI, input: string) {
    if (item.dimension === "沟通表达" || item.dimension === "形象素质") {
      if (input === ".") {
        item.score = 0;
      }
      const fInt = input.match(/[^0-9.]+/g);
      if (fInt) {
        item.score = Number(input.replace(fInt[0], ""));
      }
      const fLot = input.match(/^([0-9]\d*)(\.\d{1,2})?/);
      const dotIndex = input.indexOf(".");
      if (dotIndex !== input.lastIndexOf(".")) {
        item.score = isNaN(Number(input.substring(0, input.lastIndexOf("."))))
          ? 0
          : Number(input.substring(0, input.lastIndexOf(".")));
      }
      if (input[input.length - 1] === ".") {
        input.indexOf(".");
      } else if (fLot) {
        item.score = Number(fLot[0]);
      }
    } else {
      const fInt = input.match(/[^0-9]+/g);
      if (fInt) {
        item.score = Number(input.replace(fInt[0], ""));
      }
    }
    if (item.score > item.scoreAll) {
      item.score = item.scoreAll;
    }
    // item.score = Number(item.score)
  }
  textareaChange(e: string | number) {
    this.hasChange = true;
  }
  scoreChange(item: AI, e: string | number) {
    item.score = Number(e);
    this.hasChange = true;
  }
  reset() {
    this.hasChange = false;
    this.resultText = this.sourceInfoMap.resultText;
    this.resultStatus = this.sourceInfoMap.resultStatus;
    this.dimensionReport = JSON.parse(
      JSON.stringify(this.sourceInfoMap.dimensionReport)
    );
    this.scoreHrNew = this.sourceInfoMap.scoreHrNew;
  }
  scrollIntoQus(id: string) {
    const el: HTMLElement = document.getElementById(id) as HTMLElement;
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }
}
